import { render, staticRenderFns } from "./CockpitCard.vue?vue&type=template&id=43b07fb2&scoped=true"
import script from "./CockpitCard.vue?vue&type=script&lang=js"
export * from "./CockpitCard.vue?vue&type=script&lang=js"
import style0 from "./CockpitCard.vue?vue&type=style&index=0&id=43b07fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b07fb2",
  null
  
)

export default component.exports